<template>
  <div id="TemplateFileCard" class="card rounded">
    <header class="card-header">
      <p class="card-header-title">{{ file_name }}</p>
    </header>
    <div class="card-image">
      <img :src="image" />
    </div>
    <div class="card-content">
      <div class="content">
        {{ desc }}
      </div>
    </div>
    <footer class="card-footer">
      <a class="card-footer-item" @click.prevent="downloadFileAxios(type)"
        >Download</a
      >
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TemplateFileCard",
  props: ["file_name", "image", "type", "desc"],
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    getFileProperties: function(file_type) {
      let file_path = "template_files/";
      let export_name = "";

      switch (file_type) {
        case "personalized":
          export_name = "client_personalized.pdf";
          file_path = file_path + "client_personalized.pdf";
          break;

        case "insurance":
          export_name = "insurance_info.pdf";
          file_path = file_path + "insurance_info.pdf";
          break;

        case "disclaimer":
          export_name = "disclaimer.pdf";
          file_path = file_path + "disclaimer.pdf";
          break;

        default:
          break;
      }
      return { file_path, export_name };
    },
    downloadFileAxios: function(file_type) {
      let file_object = this.getFileProperties(file_type);
      axios({
        url: this.publicPath + file_object.file_path,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_object.export_name);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
};
</script>

<style scoped>
.rounded {
  border-radius: 12px;
}
</style>
